import { Stack } from "@mui/material"
import {
  FieldSection,
  FieldSectionTitle,
  FormCheckboxField,
  FormContainer,
  FormRoleConfContext,
  FormSwitchField,
  FormTextField,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { formRoleConf } from "./PatientServices.formRoleConf"
import { PatientServicesEnum } from "./PatientServices.schema"
import { orderDeliveryServicesReferential } from "./referential/orderDeliveryService.referential"

export const PatientServices = () => {
  const conf = useRoleConf(formRoleConf)

  return (
    <FormRoleConfContext.Provider value={conf}>
      <FormContainer>
        <FieldSectionTitle title="Services patients" />

        {/* SCAN */}
        <FieldSection
          title="Scan d’ordonnance"
          subtitle="Activer ou désactiver le service"
        >
          <FormSwitchField
            name={PatientServicesEnum.HAS_PRESCRIPTION_SCANNER}
            toggleLabels={["Non", "Oui"]}
          />
        </FieldSection>

        {/* DELIVERY SERVICE */}
        <FieldSection
          title="Commandes & livraison"
          subtitle="Sélectionner les différents services"
        >
          <Stack direction="column">
            {orderDeliveryServicesReferential.map(({ label, code }) => (
              <FormCheckboxField
                key={code}
                name={`${PatientServicesEnum.ORDER_DELIVERY_SERVICES}.${code}`}
                label={label}
              />
            ))}
          </Stack>
        </FieldSection>

        {/* ONLINE APPOINTMENT SERVICE */}
        <FieldSection
          title="Mes RDV Santé"
          subtitle="Renseigner l'adresse de prise de RDV"
        >
          <FormTextField
            name={PatientServicesEnum.HEALTH_APPOINTMENT_URL}
            label="Service prise de RDV en ligne"
            type="url"
          />
        </FieldSection>
      </FormContainer>
    </FormRoleConfContext.Provider>
  )
}
